import type { ReactNode } from 'react';

interface OpcaoSelecaoProps {
  checked: boolean;
  onChange: () => void;
  tipo: 'radio' | 'checkbox';
  disabled?: boolean;
  children: ReactNode;
}

export default function OpcaoSelecao({
  checked,
  onChange,
  tipo,
  disabled,
  children,
}: OpcaoSelecaoProps) {
  return (
    <button
      type="button"
      onClick={onChange}
      disabled={disabled}
      className={`flex w-full items-start gap-3 rounded-md px-3 py-3 text-left transition-colors ${
        disabled
          ? 'cursor-not-allowed opacity-50'
          : 'cursor-pointer hover:bg-background-100'
      }`}
    >
      {tipo === 'radio' ? (
        <span
          className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
            checked ? 'border-primary-500' : 'border-secondary-400'
          }`}
        >
          {checked && <span className="h-2.5 w-2.5 rounded-full bg-primary-500" />}
        </span>
      ) : (
        <span
          className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-sm border-2 ${
            checked ? 'border-primary-500 bg-primary-500' : 'border-secondary-400'
          }`}
        >
          {checked && <i className="ri-check-line text-sm text-white" />}
        </span>
      )}
      <span className="min-w-0 flex-1 text-[15px] text-foreground-950">{children}</span>
    </button>
  );
}